import { Progress } from "antd";
import React, { useCallback, useState } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { CardIcons, claimBonus } from "../../data/wallet";
import { calculateTimeDifference, showErrorToast } from "../../actions/helper";
import { formatAmount, getCurrentTurnoverAndRequiredTurnover } from "../../actions/util";
import promotionErrorConfigModule from "../promotionModalConfigModule";
import PromotionOneWalletModal from "../../pages/PromotionOneWalletModal";
import { piwikBonus } from "../../actions/piwikUtil";
import { CountdownTimer } from "../Wallet/OWForm/OWutil";

const AppliedClaimablePromotionCard = ({item, updateAppliedHistory = () => {}}) => {
  console.log("AppliedClaimablePromotionCard", item);
  let [currentTurnover, requiredTurnover] = getCurrentTurnoverAndRequiredTurnover(item);
  const [promotionsApplicationModalProps, setPromotionsApplicationModalProps] = useState({});
  console.log("currentTurnover", currentTurnover);
  console.log("requiredTurnover", requiredTurnover, Number(currentTurnover) >= Number(requiredTurnover));

  let isCompleted = Number(currentTurnover) >= (requiredTurnover);
  const [modalConfig, setModalConfig] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#fff",
        padding: "16px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
        maxWidth: "400px",
      }}
    >
      {/* Header with Title and Icons */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
        <h4 style={{ margin: 0, fontWeight: "bold" }}>{item?.bonusName || '---'}</h4>
        <div style={{ display: "flex", gap: "8px" }}>
            <CardIcons
                productGroups={{
                    productGroup: item?.productGroup,
                }}
            />
        </div>
      </div>

      {/* Reward Amount */}
      <div style={{ marginBottom: "16px", display: "flex", justifyContent: "space-between" }}>
        <p style={{ margin: 0 }}>Thưởng có sẵn</p>
        <h3 style={{ margin: 0, color: "#000" }}>{item?.bonusAmount} đ</h3>
      </div>

      {/* Deadline */}
      <div style={{ marginBottom: "16px", display: "flex", justifyContent: "space-between" }}>
        <p style={{ margin: 0 }}>Đếm ngược đến hết giờ</p>
        <p style={{ margin: 0, color: "#888" }}><CountdownTimer deadline={item?.expiredDate}/></p>
      </div>

      {/* Progress Section */}
      <div style={{ marginBottom: "16px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ margin: 0 }}>Tiến độ Doanh thu<span style={{ margin: 0, textAlign: "right", color: "#666666" }}>
          <span style={{
          paddingLeft: "10px",
          color: isCompleted ? "#00A6FF" : "#666666",
          }}>{formatAmount(currentTurnover)}</span> / {formatAmount(requiredTurnover)}
        </span></p>
          {isCompleted && (
            <div style={{ display: "flex", alignItems: "center", color: "#00A6FF" }}>
              <span
              style={{
                marginRight: "5px",
              }}
              >
                <img src="/vn/img/1wallet/00/isProgressComplete.svg" alt="isProgressComplete"/>
              </span>
              Đã hoàn thành
            </div>
          )}
        </div>
      </div>

      {/* Button */}
      <div
      onClick={() => {
          let config = promotionErrorConfigModule.ClaimableClickModal
          setModalConfig(config)
          setIsModalVisible(true)
          setPromotionsApplicationModalProps({
            callbackAfterSuccess: () => {
              updateAppliedHistory();
            },
            bonus: item,
          })
          piwikBonus.run19();
      }

      }
        style={{
          width: "100%",
          textAlign: "center",
          color: "#00A6FF",
          paddingTop: "10px",
          cursor: "pointer",
          fontWeight: "bold",
          borderTop: "1px solid #E3E3E3",
        }}
      >
        Nhận Thưởng
      </div>
      <PromotionOneWalletModal
        config={modalConfig}
        isVisible={isModalVisible}
        props={promotionsApplicationModalProps}
        onClose={() => {
          setIsModalVisible(false)
        }}
      />
    </div>
  );
};

export default AppliedClaimablePromotionCard;
